export default "__VITE_ASSET__brHn6a6Y__"